import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { Container } from 'react-bootstrap';
import WeatherCard from 'features/Weather/components/WeatherCard/WeatherCard';
import 'features/Weather/assets/weatherDataDisplay.css';
import ConditionIcons from 'features/Weather/components/ConditionIcons/ConditionIcons';

const WeatherCardGrid = ({
  loading,
  pageHeading,
  forecast = [],
  cardDetails,
  getCardTitle,
  getCardIcon,
  getCardKey,
  emptyMessage = 'No data available',
}) => {
  return (
    <Container
      fluid
      className="weather-data-display d-flex flex-column h-100 user-select-none gap-3 px-0"
    >
      {!loading ? (
        <>
          {pageHeading && (
            <div className="pb-2 border-bottom weather-data-display-heading">
              <h2 className="m-0 fw-bold lh-sm weather-data-display-title">{pageHeading}</h2>
            </div>
          )}

          {forecast.length ? (
            <div>
              <div className="row g-4">
                {forecast.map((item, index) => (
                  <div
                    key={getCardKey?.(item, index) ?? index}
                    className="col col-12 col-md-6 d-flex"
                  >
                    <WeatherCard
                      weatherObj={item}
                      title={getCardTitle(item)}
                      headerIcon={
                        getCardIcon?.(item) ?? (
                          <ConditionIcons conditionId={parseInt(item?.icon || '0', 10)} size={25} />
                        )
                      }
                      details={cardDetails}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className="m-0">{emptyMessage}</p>
          )}
        </>
      ) : (
        <WidgetLoadingAnimation />
      )}
    </Container>
  );
};

export default WeatherCardGrid;
